import React from 'react';
import './HeroSection.css';

const HeroSection = ({ settings }) => {
  return (
    <section id="inicio" className="hero-section">
      <div className="hero-image-container">
        <img
          src={settings.hero_image}
          alt="Centro Terapéutico Crecer Juntos"
          className="hero-image"
        />
      </div>
    </section>
  );
};

export default HeroSection;
